module.exports = __webpack_public_path__ + "img/doc_1_full.46901fbe.jpg";